module.exports = __webpack_public_path__ + "static/media/sleigh.cd231075.svg";